var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnDrugRedue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "white",
    stroke: "#0D5CDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3194 9.056V10.688H5.67938V9.056H10.3194Z",
    fill: "#0D5CDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDrugRedue);
export default __webpack_public_path__ + "static/media/btn_drug_redue.d8d784b68a861517a0435323b1b499c3.svg";
export { ForwardRef as ReactComponent };